<template>
  <v-container fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="secondary"
          icon="mdi-exit-run"
          :title="$t('radiate_affiliated')"
        >
          <v-layout justify-center style="flex-wrap: wrap">
            <my-datepicker
              v-model="lastDateTes"
              :label="$t('last_affiliation_card_renew')"
              @change="loadTable()"
              required="true"
            />

            <v-btn small @click="radiateUsers" color="error">{{
              $t("radiate_selected")
            }}</v-btn>
          </v-layout>
          <DataTables
            @showUser="showUser"
            :headers="headers"
            :selected="selected"
            :showSelect="true"
            itemKey="masterId"
            v-model="selected"
            :tableData="tableData"
          ></DataTables>
        </base-material-card>
        <profile-page ref="userProfileDialog"></profile-page>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";
import profilePage from "@/app/UserProfile.vue";
import MyDatepicker from "@/components/base/MyDatepicker.vue";

import Swal from "sweetalert2";
import moment from "moment";

let _ = this;
export default {
  name: "radiazione-soci",
  components: {
    DataTables,
    profilePage,
    MyDatepicker,
  },
  data() {
    return {
      lastDateTes: null,
      dialogShowUser: false,
      selected: [],
      headers: [
        { text: this.$t("avatar"), value: "avatarUrl", type: "image" },
        { text: this.$t("surname"), value: "surname" },
        { text: this.$t("name"), value: "name" },
        { text: this.$t("email"), value: "email" },
        { text: this.$t("residence_address"), value: "resCity" },
        { text: this.$t("telephone"), value: "telephone" },
        { text: this.$t("eta"), value: "eta", type: "numeric" },
        { text: this.$t("last_season"), value: "stagione" },
        {
          text: this.$t("type_affiliation_card"),
          value: "tesseraClub",
          type: "html",
        },
        {
          text: this.$t("number_affiliation"),
          value: "tesseraEnte",
          type: "html",
        },
        { text: this.$t("options"), value: "options", type: "buttons" },
      ],
      tableData: [],
    };
  },

  methods: {
    radiateUsers: function (data) {
      let url = "/auth/tesseramenti/radiateUsers";
      let _ = this;
      _.tableData = [];
      _.isFetching = true;
      _.chiamataAxios("POST", url, {
        dialogLoader: true,
        body: { users: _.selected },
      }).then((response) => {
        if (response.msg.esito) _.loadTable();
      });
    },

    showUser(item) {
      this.$refs.userProfileDialog.open(item.id, 4);
    },

    loadTable() {
      let now = moment();
      let oneYearAgo = now.subtract("years", 2);
      let url = "/auth/portal/listUsers";
      let _ = this;
      if (!_.lastDateTes) _.lastDateTes = now;
      _.tableData = [];
      _.isFetching = true;
      this.chiamataAxios("POST", url, {
        body: { filter: { lastDateTes: _.lastDateTes, type: "soci" } },
      }).then((response) => {
        _.tableData = response.data.map(function (item) {
          item.stagione =
            item.tesseraInterna.length > 0
              ? item.tesseraInterna[0].stagione
              : "";
          //item.url = _.authorizeLink(item.url);
          item.tesseraClub =
            item.tesseraInterna.length > 0
              ? '<h4 style="color: ' +
                item.tesseraInterna[0].asdTesHexColor +
                ';">' +
                item.tesseraInterna[0].asdTesTipo +
                " - " +
                item.tesseraInterna[0].asdTesNum +
                "</h4>" +
                new Date(item.tesseraInterna[0].dateTes).toLocaleDateString(
                  "it"
                )
              : "";
          item.tesseraEnte =
            item.tesseraEnte.length > 0
              ? '<h4 style="color: ' +
                item.tesseraEnte[0].asdTesHexColor +
                ';">' +
                item.tesseraEnte[0].asdTesTipo +
                " - " +
                item.tesseraEnte[0].asdTesNum +
                "</h4>" +
                new Date(item.tesseraEnte[0].dateTes).toLocaleDateString("it")
              : "";

          item.options = [
            {
              icon: "mdi-magnify",
              color: "primary",
              function: "showUser",
            },
          ];
          return item;
        });

        _.isFetching = false;
      });
    },
  },
  created() {
    this.loadTable();
  },
};
</script>

